import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule, ModalController } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { AutomationRun } from 'src/models';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';
import { AuthService } from 'src/services/auth.service';
import { AutomationsService } from 'src/services/automations.service';
import { ConversationsService } from 'src/services/conversations.service';
import { MessageService } from 'src/services/message.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, NgxDatatableModule, SharedPipesModule, RouterModule],
  selector: 'app-automation-logs',
  templateUrl: './automation-logs.component.html',
  styleUrls: ['./automation-logs.component.scss'],
})
export class AutomationLogsComponent implements OnInit {
  run: Partial<AutomationRun>;
  conversationFriendlyId?: string;
  isLoading: boolean = false;
  hideMetadata = false;
  automationRunLogs: string[];
  input?: Record<string, any>;

  constructor(
    public authService: AuthService,
    private modalCtrl: ModalController,
    private msgService: MessageService,
    private automationsService: AutomationsService,
    private conversationsService: ConversationsService,
  ) {}

  async ngOnInit() {
    this.getLogs();
  }

  async getLogs() {
    this.isLoading = true;
    this.automationRunLogs = [];

    const { automationId, id } = this.run;

    const logs = await this.automationsService.listLogEntriesForRun(automationId, id);
    this.conversationFriendlyId = (
      await this.conversationsService.get(this.run.input.conversationId, ['friendlyId'])
    )?.friendlyId;

    this.automationRunLogs = logs.map((log) => {
      const isError = log.severity === 'ERROR';
      const emoji = isError ? '❌' : '✅';
      const prefix = this.hideMetadata ? '' : `${emoji} - ${log.timestamp} - `;

      return `${prefix}${log.message}`;
    });

    this.isLoading = false;
  }

  copyToClipboard() {
    const logsText = this.automationRunLogs.join('\n');
    navigator.clipboard.writeText(logsText);
    this.msgService.show('Copied');
  }

  viewConversation() {
    if (this.run?.input?.conversationId) {
      this.modalCtrl.dismiss();
      // Navigate to conversation
      window.open(`/dashboard/inbox/me/conversations/${this.run?.input?.conversationId}`, '_blank');
    }
  }

  viewAutomation() {
    if (this.run?.automationId) {
      this.modalCtrl.dismiss();
      // Navigate to automation editor
      window.open(`/dashboard/automations/${this.run.automationId}`, '_blank');
    }
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
